export default {
  viewReport: 'View Report',
  viewHistory: 'History',
  registerNo: 'Register No',
  revNo: 'Rev No',
  hospitalLabNo: 'Hospital Lab No',
  pathoNo: 'Patho No',
  prefix: 'Prefix',
  name: 'Patient Name',
  hn: 'HN',
  physicianName: 'Physician Name',
  customer: 'Customer',
  receivedDate: 'Receive Date',
  dateReported: 'Report Date',
  dueDate: 'Due Date',
  tat: 'Turn Around Time',
  labelDateFrom: 'Receive Date From',
  labelDateTo: 'Receive Date To',
  labelBtnFind: 'Find',
  labelPathoPendingList: 'Pathologist Pending Report',
  labelPathoCompleteList: 'Pathologist Complete Report',
  labelPathoHistory: 'Pathology History Report',
  labelPathoCytologistPendingList: 'Cytologist Pending Report',
  labelPathoGrossPendingList: 'Gross Pending Report',
  labelPathoCytologistCompleteList: 'Cytologist Complete Report',
}
